export default {
  sample: {
    home2: 'ホーム（別パターン）',
  },
  common: {
    hrportal: 'ダッシュボード',
    menu: 'メニュー一覧',
    commonSetting: '全体設定',
    ok: 'OK',
    cancel: 'キャンセル',
    close: '閉じる',
    save: '保存',
    back: '戻る',
    add: '追加',
    reset: 'リセット',
    create: '作成',
    caution: '注意点',
    noDataFound: 'データが見つかりません',
    saved: '保存しました',
    copied: 'コピーしました',
    deleted: '削除しました',
    delete: '削除',
    upload: 'アップロード',
    format: 'フォーマット',
    all: '全て',
    selectTarget: '対象を選択する',
    goBackToEditing: '編集画面に戻る',
    discard: '破棄',
    discardDialogTitle: '保存されていない変更を破棄しますか？',
    discardConfirmMessage: '破棄をした場合、行った変更は保存されません',
    week: {
      mon: '月',
      tue: '火',
      wed: '水',
      thu: '木',
      fri: '金',
      sat: '土',
      sun: '日',
    },
    goHomeText: 'ホームへ戻る',
  },
  appbar: {
    placeholder: 'メニュー検索',
    searchMessage: 'メニュー名及びメニュー詳細で検索してください',
    setting: '個人設定',
    logout: 'ログアウト',
    userManual: 'ユーザーマニュアル',
    version: 'バージョン',
    aboutFbs: 'File Bridge Schedulerについて',
    aboutPortal: 'COMPANY HR Portalについて',
    fbsCopyright: '© 2025 Works Human Intelligence Co., Ltd.',
    portalCopyright: '© 2023 Works Human Intelligence Co., Ltd.',
    ossLicense: 'OSSライセンス',
  },
  sidemenu: {
    home: 'ホーム',
  },
  portal: {
    notification: 'お知らせ',
    event: 'イベント情報',
    favorite: 'お気に入り',
    hideFavorite: 'お気に入りを非表示にする',
    updateFavorite: 'お気に入りの管理',
    history: '最近使ったメニュー',
    links: 'リンク集',
    unavailableDescription: 'ご利用の端末からはアクセスできません',
    nofavoritemsg: 'からお気に入りメニューを追加することができます',
    titleHideFavorite: 'お気に入りを非表示にします',
    titleHideFavoriteSub1: 'お気に入りパネルを画面上に表示しないようにします。',
    titleHideFavoriteSub2: '設定から再度表示することができます。',
    titleUpdateFavorite: 'お気に入りの管理',
    updateLink: 'リンク集を編集する',
    linkEditTitle: 'リンク名',
    linkEditUrl: 'URL',
    linkEditDescription: '説明',
    linksUpdation: 'リンク集の編集',
    linkAdd: 'リンクの追加',
    linkEdit: 'リンクの編集',
    ruleInputRequired: '入力してください',
    ruleInputUnique: '指定したジョブコードは既に存在しています',
    ruleInputAlphanumericFormat:
      '半角英数字とアンダースコア(_)以外の文字は入力できません',
    ruleInputRegExpCompilable:
      'マッチパターンとして正常に処理できません。記号などは特別な意味を持つ場合があります。詳しくはユーザーマニュアルを参照してください',
    ruleInputUrl: '正しいURLを入力してください',
    ruleSSMParameterStoreName:
      '英字、数字、と次の3つの記号.-_のみを使用できます。',
    noData: 'データがありません',
    disableDueToNotInHouse: '社外からは利用できないメニューです',
    application: 'アプリケーション',
    seeAll: 'すべてを見る',
    announcement: 'お知らせ',
    announcements: 'お知らせ一覧',
  },
  setting: {
    settingItemLanguage: '言語',
    settingItemUseFavorite: 'お気に入り機能を利用する',
    updatedMessage: '更新しました',
    regionAndLanguage: '表示',
    generalSetting: '利用設定',
  },
  commonSetting: {
    tabs: {
      announcement: 'お知らせ',
      webApi: '連携設定',
      general: '利用設定',
      userManagement: 'ユーザー管理',
      role: 'ロール',
    },
    announcementTableColumn: {
      title: 'タイトル',
      content: '内容',
      linkToProductMenu: 'リンク',
      isPublic: '公開設定',
      displayStartDate: '開始日',
      displayEndDate: '終了日',
      priorityTag: '重要度',
      updatedAt: '更新日時',
    },
    isPublicLabel: {
      public: '公開',
      private: '非公開',
    },
    priorityTagLabel: {
      high: '高',
      medium: '中',
      low: '低',
    },
    cardTitle: {
      newItem: '新規作成',
      editItem: '編集',
    },
    error: {
      afterTodayDate: '終了日には今日以降の日付を指定してください',
      beforeStartDate: '終了日には開始日以降の日付を指定してください',
      required: 'この項目は必須です',
      invalidDate: 'は有効な日付ではありません',
    },
    general: {
      settingItemMultilanguage: '多言語を利用する',
      settingItemUseJobScheduler: 'ジョブ及びスケジューラー機能を利用する',
      useV1: 'CWSのお知らせを利用する',
      useV2: 'COMPANY HR Portalのお知らせを利用する',
      notUse: 'お知らせを利用しない',
      saveConfirmation: '変更内容を保存しますか？',
    },
    webApi: {
      authenticationInfoSetting: '認証情報',
      authenticationInfoSettingHint:
        'CJKのClient-ID管理画面で設定したClient IDとClient Secretを利用してください',
      clientId: 'Client ID',
      clientSecret: 'Client Secret',
      createDialogTitle: '認証情報を保存しますか？',
      deleteDialogTitle: '認証情報を削除しますか？',
      createTooltip: 'Client IDとClient Secretを保存する',
      deleteTooltip: 'Client IDとClient Secretを削除する',
      deleteDialogText: `認証情報を削除するとジョブの即時実行やスケジュール実行が失敗します。認証情報はこのアプリケーションからは削除されますが、CJKのClient-ID管理画面からは削除されません。`,
    },
    userManagement: {
      searchHint: 'ユーザー名またはユーザーロールで検索',
      userDetail: 'ユーザー詳細',
      adminRole: '管理者',
      generalRole: '一般',
      userNameHeader: 'ユーザー名',
      userRoleHeader: 'ユーザーロール',
      roleHeader: 'ロール',
      selectRole: 'ロールを選択',
      searchToLoadUserDetails: '検索実行によりユーザー情報を読み込みます',
      sameAsLoggedInUser: '自身のユーザロールは変更または削除できません',
      deleteDialogTitle: 'ユーザーデータの削除',
      deleteDialogTextDeleteUserDataConfirmation:
        'このユーザーに紐づくすべての情報を完全に削除します：',
      deleteDialogPortalDataDeletionCaution: `・本削除操作は、COMPANY HR Portalに保存されている、ユーザー情報及び当該ユーザーに紐づく情報を削除するものです。
      COMPANY HR Portalへのログイン可否については、シングルサインオンに利用されているSAML IdPの資格情報の有無に依存します。
      当該ユーザーによるCOMPANY HR Portalへのログインを不可能にするためには、SAML IdPにおける当該ユーザーの資格情報の削除が必要です。`,
      deleteDialogSamlLoginCaution: `・本操作による削除後に、SAML IdPにおける当該ユーザー情報の資格情報によるログインを実施した場合、新規ユーザーとして、当該ユーザー名を持つユーザーが作成されます。`,
      deleteDetailsConfirmation: `以下のデータが削除されます。一度削除操作を行うと、当該データを元に戻すことは不可能になります。問題がなければチェックボックスにチェックを入れてください。`,
      deleteDetailsConfirmUserDataDelete:
        'ユーザー情報及び、当該ユーザーに紐づくすべての情報が削除されます',
      deleteDetailsConfirmUserDataReplace:
        'そのユーザーに関する言及はすべて「deleted user」というテキストに置き換えられます',
      typeUserName:
        '削除を実行する場合、以下の入力欄にユーザー名を入力してください。ユーザー名の入力により、「削除」ボタンが有効になります。',
      deletionProcessStarted: 'ユーザーデータの削除処理を開始しました',
      deletionProcessComplete: 'ユーザーデータが削除されました',
      deletionProcessFailed: 'ユーザーデータの削除に失敗しました',
    },
    roleManagement: {
      title: 'ロール管理',
      createNewRole: '新規ロール作成',
      systemRole: 'システムロール',
      roleNameHeader: 'ロール名',
      defaultHeader: 'デフォルト',
      descriptionHeader: '説明',
      actionsHeader: '操作',
      yes: 'はい',
      no: 'いいえ',
      edit: '編集',
      delete: '削除',
      systemRoleCannotBeDeleted: 'システムロールは削除できません',
      deleteDialogTitle: 'ロールの削除',
      deleteConfirmMessage: 'を削除してもよろしいですか？',
      cancel: 'キャンセル',
      loadFailed: 'ロールの読み込みに失敗しました',
      deleteSuccess: 'ロールを削除しました',
      deleteFailed: 'ロールの削除に失敗しました',
      usersAssignedDialogTitle: 'ロールを削除できません',
      usersAssignedMessage:
        'このロールには {count} 人のユーザーが所属しています。ロールを削除する前に、すべてのユーザーを他のロールに移動してください。',
    },
    roleEdit: {
      editTitle: 'ロールの編集',
      createTitle: '新規ロール作成',
      systemRoleCannotBeEdited: 'システムロールは編集できません',
      roleName: 'ロール名',
      roleNameRequired: 'ロール名は必須です',
      description: '説明',
      defaultRoleLabel: '初回ログインユーザーのデフォルトロール',
      defaultRoleHint:
        'デフォルトロールは1つだけ設定できます。このロールをデフォルトに設定すると、既存のデフォルトロールは自動的に解除されます。',
      menuPermissionsLabel: 'メニュー表示権限',
      scheduler: 'スケジューラー',
      job: 'ジョブ',
      settings: '全体設定',
      cannotChangeOwnRoleSettings:
        '自分が所属しているロールの全体設定権限は変更できません',
      home: 'ホーム',
      sitemap: 'メニュー一覧',
      cancel: 'キャンセル',
      update: '更新',
      create: '作成',
      settingsPermissionDialogTitle: '権限付与の確認',
      settingsPermissionWarning:
        '注意：全体設定権限を付与すると、テナント内の全ユーザーの情報が閲覧可能になります。この権限は慎重に割り当ててください。',
      grant: '付与する',
      disablePermissionDialogTitle: '権限無効化の確認',
      disableSettingsConfirm: '全体設定権限を無効にしてもよろしいですか？',
      disable: '無効にする',
      defaultRoleDialogTitle: 'デフォルトロール設定の確認',
      defaultRoleWarning:
        '注意：既にデフォルトロールとして設定されている「{roleName}」のデフォルト設定が自動的に無効化されます。よろしいですか？',
      set: '設定する',
      fetchFailed: 'ロール情報の取得に失敗しました',
      noPermission: 'このロールにアクセスする権限がありません',
      updateSuccess: 'ロールを更新しました',
      createSuccess: 'ロールを作成しました',
      saveFailed: 'ロールの{action}に失敗しました',
    },
  },
  dataTable: {
    footer: {
      itemsPerPageText: '1ページあたりの行数',
    },
  },
  search: {
    notFound: 'に一致する情報は見つかりませんでした。',
    results: '件',
    seconds: '秒',
  },
  errorBoundary: {
    title: '予期しないエラーが発生しました',
    occurredTime: '発生時刻',
    errorCode: 'エラーコード',
    errorTitle: 'エラータイトル',
    argsInfo: '引数情報',
    errorMessage: 'エラーメッセージ',
    stackInfo: 'エラー詳細',
    errorInfo: 'エラー情報',
  },
  editor: {
    // Write the key in a snake case according to the library we are using
    tooltip: {
      undo: '元に戻す',
      redo: 'やり直す',
      bold: '太字',
      italic: '斜体',
      strike: '取り消し線',
      underline: '下線',
      code: 'コード',
      paragraph: 'パラグラフ',
      heading: '見出し',
      bullet_list: '箇条書き',
      ordered_list: '番号付きリスト',
      horizontal_rule: '水平線',
    },
  },
  productMainMenu: {
    CSR: '就労・プロジェクト管理',
    CWS: 'Web Service',
    CJK: '人事・給与',
    CTM: 'タレントマネジメント',
  },
  productMainMenuForTakeda: {
    CSR: '勤怠管理',
    CWS: '人事関連申請',
    CJK: '人事・給与',
    CTM: 'タレントサーチポータル',
  },
  announcement: {
    highPriorityFlg: '高',
    mediumPriorityFlg: '中',
    lowPriorityFlg: '低',
    displayPeriodLabel: '掲載期間',
    contentLabel: '内容',
    updateDateLabel: '更新日時',
    urlLabel: 'URL',
    noAnnouncement: 'お知らせはありません',
  },
  pageNotEnabled: {
    titleText: 'この機能はご利用いただけません',
    subText: 'この機能を有効にするためには、管理者にお問い合わせ下さい。',
  },
  pageNotFound: {
    titleText: 'ページが見つかりません',
    subText:
      'リクエストされたページは、削除されたか、移動した可能性があります。',
  },
  jobScheduler: {
    common: {
      scheduler: 'スケジューラー',
      period: {
        title: '期間',
        to: '終了日',
        from: '開始日',
        executeOn: '実行日',
        setAt: '設定日',
      },
      repeatType: {
        itemName: '繰り返しタイプ',
        repeatTypeOptions: {
          noRepeat: '繰り返さない',
          daily: '毎日',
          monthly: '毎月',
          weekly: '毎週',
          firstDayOfMonth: '月初',
          lastDayOfMonth: '月末',
        },
      },
      holidayLabel: {
        title: 'ラベル',
        placeholder: 'ラベルを入力してください',
        notFound:
          'に一致する結果はありません。 Enterキーを押して、新しいラベルを作成します',
        allSelected: 'Enterキーを押して、新しいラベルを作成します',
      },
      accessFromOutsideOfJST: {
        titleText:
          'このページにアクセスするには、システムのタイムゾーンが日本標準時（JST）である必要があります',
        subText:
          'システムのタイムゾーンが日本標準時（JST）に設定されていません。このページにアクセスするには、タイムゾーンを日本標準時（JST）に設定してください。',
      },
      accessFromIOS: {
        titleText: 'このページは推奨環境でご利用ください',
        subText:
          'ご利用いただいているデバイスまたはブラウザでは、画面が正しく表示されない可能性があります。ユーザーマニュアルに記載されている推奨環境でのご利用を推奨しています。',
        ignoreWarning: '理解して続行',
      },
      abortAndDelete: '停止及び削除',
      abortedAndDeleted: '停止及び削除を完了しました',
      copy: 'コピー - ',
      dateToLessThanDateFrom: '終了日が開始日より前の日付になっています',
      moreActions: 'その他の設定',
      notSelectedDates: '日付を選択してください',
      notSelectedDays: '曜日を選択してください',
      notSelectedEndDateHint: '終了日を指定しない場合、永続的に実行されます',
      notSelectedPeriod: '期間を選択してください',
      editTooltip: '編集',
      viewTooltip: '表示',
      viewDisabledDueToNoEventMetadataToolTip:
        '最終実行日が3年以上経過しているため詳細表示できません',
      copyTooltip: '複製',
      copyDisabledDueToNoEventMetadataToolTip:
        '最終実行日が3年以上経過しているため複製できません',
    },
    eventCalendar: {
      calendar: 'カレンダー',
      list: 'リスト',
      search: '検索',
      clear: '設定をクリア',
      executionStatus: '実行ステータス',
      executionType: '実行タイプ',
      downloadSearchResult: '検索結果をダウンロード',
      task: 'タスク',
      showMore1: 'もっと見る（全 ',
      showMore2: ' 件）',
      searchResult: '検索結果: ',
      item: ' 件',
      invalidDate: '日時が不正です',
      notSpecified: '指定なし',
      immediate: '即時実行',
      scheduled: 'スケジュール実行',
      throughAPI: 'API実行',
      throughFsync: 'ファイルトリガー実行',
      retry: '再実行',
      succeeded: '成功',
      failed: '失敗',
      notTriggered: '未実行',
      running: '実行中',
      todayText: '今日',
      job: 'ジョブ',
      output: '出力',
      download: 'ダウンロード',
      executedBy: '実行者',
      executedAt: '実行開始日時',
      executeCompletedAt: '実行終了日時',
      executeAt: '実行予定日時',
      updatedBy: '最終更新者',
      updatedAt: '最終更新日時',
      result: '結果',
      labels: 'ラベル',
      moreThan1000ConsecutiveHolidayDialogTitle:
        'サポートされていないイベントが存在します',
      moreThan1000ConsecutiveHolidayDialogText:
        '休祝日トリガー設定に1000日以上連続した休祝日を設定しているイベントが存在しています。\
        このようなイベントは仕様上サポートされていないため、イベントの実行日の計算に失敗しました。\
        1000日以上連続している休祝日を削除するか、該当のイベントの休祝日トリガー設定を変更して下さい。\
        該当のイベントは{eventDetailLink}。',
      eventText: 'こちら',
    },
    jobs: {
      title: 'ジョブ',
      addNewTask: 'タスク追加',
      jobCode: 'ジョブコード',
      jobCodeDescription: 'ジョブを一意に管理するための文字列です',
      jobCodeHint: '※一度保存するとこの値は編集できません',
      jobTitle: 'ジョブタイトル',
      jobDescription: 'ジョブ説明',
      jobTriggerFilePath: 'トリガーファイルパス',
      jobTriggerFilePathDescription:
        'ファイル同期用エージェント（FileSynchronizer Agent Service）を使って、ファイルのアップロードをジョブの開始きっかけにしたい場合は、対象のファイルの場所を特定するためのパターンを設定してください。このパターンは正規表現のルールに基づいて指定しますので、詳しい形式についてはユーザマニュアルをご参照ください。',
      taskDetail: 'タスク詳細',
      notSetTask: 'タスクが選択されていません',
      taskSelection: 'タスクを選択してください',
      newJob: '新規作成',
      searchJobTitle: 'ジョブタイトルを入力して下さい',
      searchJobTitleOrJobCode: 'ジョブタイトルまたはジョブコードで検索',
      jobExecute: '即時実行',
      noJobSelected: 'ジョブが選択されていません',
      taskTitle: 'タスクタイトル',
      addMore: 'アップロードファイルを追加',
      uploadAndExecute: 'アップロードと実行',
      uploadOnExecuteDialogTitle: 'ジョブ実行',
      uploadFileSubtitle:
        '（オプション）ジョブの実行前にCOMPANY V8にファイルをアップロードすることができます',
      destinationFilePath: 'ファイルのアップロード先のパス',
      hintForDestinationFilePath: '例）/folder1/file.txt',
      invalidPath:
        'ファイルパスが有効ではありません。有効なパス例：/folder1/file.txt',
      duplicateOutputFilePath:
        '他のタスクの出力先テキストファイルパスと重複しています',
      fileInput: 'アップロードするファイル',
      chooseFile: 'ファイルの選択',
      doUploadOnExecuteOrNotText:
        'ジョブの実行前にCOMPANY V8へのファイルアップロードを実施しますか？',
      uploading: 'アップロードを実施中',
      executing: 'ジョブの実行を実施中',
      executed: '即時実行しました',
      executedDialogTitle: '選択されたジョブを実行しました',
      executedDialogText:
        'ジョブの実行状況を{eventCalendarLink}ページから確認できます',
      includeInDownload: 'ダウンロード対象にする',
      replaceInFileName: 'ファイル名の予約語を置換する',
      selectFile: 'ジョブファイル選択',
      importJobFile: 'ジョブファイルインポート',
      importableFileDescription:
        'エクスポート機能を使用して生成されたジョブファイルのみインポート可能です。エクスポートされたファイルは編集できません',
      importableFileFormat: '※ csv・yaml(yml)ファイルのみインポート可能',
      import: 'インポート',
      exportJobFile: 'ジョブファイルエクスポート',
      exportTarget: 'エクスポート対象',
      export: 'エクスポート',
      importJobAlreadyStarted:
        '他のユーザーが現在インポートを実行中です。しばらく時間をおいて、再度お試しください',
      importJobStarted: 'ジョブのインポートを開始しました',
      importJobCompleted: 'ジョブのインポートが完了しました',
      importJobFailedStatus422:
        'ジョブのインポートに失敗しました。エクスポート後に編集されたファイルはインポートできません。',
      importJobFailedTimeout:
        'ジョブのインポートに失敗しました。時間を空けて再度お試しください。',
    },
    holidays: {
      holiday: 'カスタム休日',
      holidayTitleInput: 'カスタム休日のタイトル',
      holidayDescriptionInput: 'カスタム休日の説明',
      createHolidayTitle: '新しいカスタム休日を作成',
      copyHolidayTitle: 'カスタム休日を複製',
      updateHolidayTitle: 'カスタム休日を編集',
      viewHolidayTitle: 'カスタム休日を表示（読み取り専用）',
      holidayDetail: 'カスタム休日の詳細',
      abortDialogTitle: 'このカスタム休日を削除しますか？',
      abortTooltip: '今後予定されているこのカスタム休日を削除',
      abortConfirmMessage:
        '今後予定されているこのカスタム休日がすべて削除されます',
      notSelectedCustomHolidayLabels:
        '一つ以上のカスタム休日ラベルを選択してください',
    },
    events: {
      event: 'イベント',
      createEventTitle: '新しいイベントを作成',
      copyEventTitle: 'イベントを複製',
      updateEventTitle: 'イベントを編集',
      viewEventTitle: 'イベントを表示（読み取り専用）',
      eventTitleInput: 'イベントタイトル',
      eventDescriptionInput: 'イベントの説明',
      jobToRun: 'ジョブ',
      eventDetail: 'イベント詳細',
      executionTime: '実行時刻',
      executionDateTime: '実行日時',
      startDateTime: '開始日時',
      executionTimeNotInputted: '実行時刻を入力してください',
      abortDialogTitle: 'このイベントの停止及び削除をしますか？',
      abortTooltip:
        'このイベントのジョブを停止し、かつ今後予定されているすべてのイベントを削除',
      abortConfirmMessage:
        'このイベントのジョブは停止され、かつ今後予定されているすべてのイベントが削除されます',
      notSelectedHolidayLabels: '一つ以上のラベルを選択してください',
      retryTooltip: '再実行',
      retryDisabledDueToNoEventMetadataToolTip:
        '最終実行日が3年以上経過しているため再実行できません',
      retryDialogTitle: 'イベントを再実行',
      retryFromFailed: '失敗したタスクから再実行',
      retryAll: 'すべてのタスクを再実行',
      retry: '再実行',
      holidayTriggerSettingTitle: '休祝日トリガー設定',
      holidayTrigger: {
        label: 'トリガーの種類',
        noChange: '休祝日でも実行',
        skip: 'スキップ',
        triggerAfterHoliday: '次営業日に実行',
        triggerBeforeHoliday: '前営業日に実行',
        allHoliday: 'すべての休祝日',
        customHoliday: 'ラベル定義の休祝日 ',
        on: '休祝日対象',
        noLabelData: '登録済みのラベルがありません',
      },
      selectedToday:
        'が現在時刻より前、もしくは現在時刻と同一として設定されております。そのため、本日分のイベントは実行されません',
    },
  },
};
